"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getNorthDakotaRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _types = require("../../assets/types");

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _Rule = require("../Rule");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'ND';

function getNorthDakotaRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), (0, _commonRules.thriftSavingsPlans)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Motor Vehicles. If disabled, exemption limits become $32,000/$64,000 (Single/Joint)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-03.1(2)',
    limitAggregateSingle: 2950,
    limitAggregateJoint: 5900,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: 1,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.AUTOMOBILE];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Family Pictures',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-03.1(2)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.FAMILY_PHOTOS];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Wearing Apparel (for family)',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-02',
    limitAggregateSingle: 5000,
    limitAggregateJoint: 10000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.CLOTHES];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Personal Property (single person, not claiming crops)',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-05',
    limitAggregateSingle: 3750,
    limitAggregateJoint: 7500,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var type = _lodash["default"].get(asset, 'assetJSON.type');

      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var invalidSubtypes = [_subTypes.CROPS];
      return this.canTakeMoreExemptions() && type === _types.PERSONAL && !invalidSubtypes.includes(subType);
    },
    transformFromContext: function transformFromContext(caseObj) {
      // If "head of household" (imo, has dependents)
      if (_lodash["default"].get(caseObj, 'household.dependents', []).length > 0) {
        this.description = 'Personal Property (head of household, not claiming crops)';
        this.statuteName = 'N.D. Cent. Code § 28-22-03';
        this.limitAggregateSingle = 7500;
        this.limitAggregateJoint = 15000;
      }
    }
  }, {
    id: idCounter.increment(),
    description: 'Health Aids',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-03.1 (6)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'Food and Fuel to last 1 year',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-02 (6)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FOOD_AND_FUEL;
    }
  }, {
    id: idCounter.increment(),
    description: 'ERISA, IRAs, & Keoghs (Total)',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-03.1 (7)',
    limitAggregateSingle: 200000,
    limitAggregateJoint: 400000,
    limitPerItem: 100000,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validSubTypes = [_subTypes.IRA, _subTypes.KEOGH];
      return this.canTakeMoreExemptions() && (validSubTypes.includes(subType) || tertiaryType === _tertiaryTypes.ERISA_REITREMENT_PLAN);
    }
  }, {
    id: idCounter.increment(),
    description: 'Annuities, stock-bonus or similar plan payments',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-03.1(8)(e)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.ANNUITY];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Child Support',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 14-09-09.31',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CHILD_SUPPORT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Alimony Support',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-03.1 (8)(d)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.ALIMONY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Assistance',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-19 (3)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PUBLIC_ASSISTANCE;
    }
  }, {
    id: idCounter.increment(),
    description: "Crime Victims' Compensation",
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-19 (2); N.D. Cent. Code § 28-22-03.1 (9)(a)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: "Workers' Compensation",
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 65-05-29',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Social Security',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 65-05-29',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.SOCIAL_SECURITY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unemployment Compensation',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 52-06-30; N.D. Cent. Code § 28-22-03.1 (8)(c)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNEMPLOYMENT_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: "Disabled Veterans' Benefit",
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-03.1 (8)(b)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.VETERANS_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Employees (deferred compensation)',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 54-52.2-06',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.PUBLIC_EMPLOYEE_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal Benefit',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 54-52.2-06',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FRATERNAL_BENEFIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Personal Injury Settlement',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-03.1 (9)(d)',
    limitAggregateSingle: 18450,
    limitAggregateJoint: 36900,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PERSONAL_INJURY_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Wrongful Death Awards',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-03.1 (9)(b)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WRONGFUL_DEATH_AWARD;
    }
  }, {
    id: idCounter.increment(),
    description: 'Earnings for 60 days',
    requiresReview: true,
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-25-11',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WAGES;
    }
  }, {
    id: idCounter.increment(),
    description: "Veterans' Compensation (Desert Shield, Desert Storm)",
    requiresReview: true,
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 37-26-06',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.VETERANS_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Loss of Future Earnings Compensation',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-03 (9)(e)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PERSONAL_INJURY_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Disability, Illness, Unemployment Benefits',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-03 (8)(c)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.DISABILITY_BENEFITS || tertiaryType === _tertiaryTypes.UNEMPLOYMENT_BENEFITS);
    }
  }, {
    id: idCounter.increment(),
    description: 'Old-Age and Survivor Insurance',
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 52-09-22',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.OLD_AGE_SURVIVORS_INSURANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (unmatured, loan)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-03.1 (5)',
    limitAggregateSingle: 8000,
    limitAggregateJoint: 16000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNMATURED_TERM_INSURANCE_POLICY;
    }
  }, {
    id: idCounter.increment(),
    description: 'Proceeds for Exempt Property',
    requiresReview: true,
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-02 (9)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PROCEEDS_FOR_EXEMPT_PROPERTY;
    }
  }, {
    id: idCounter.increment(),
    description: "Life Insurance Proceeds (payable to deceased's estate)",
    requiresReview: true,
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 26.1-33-40',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.WHOLE_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Tools of Trades',
    requiresReview: true,
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-03.1 (3)',
    limitAggregateSingle: 1500,
    limitAggregateJoint: 3000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.TOOLS_OF_TRADE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Crops - on 160 acres where debtor resides',
    requiresReview: true,
    type: stateCode,
    statuteName: 'N.D. Cent. Code § 28-22-02(8)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CROPS;
    }
  }, {
    id: _Rule.WILDCARD_ID,
    type: stateCode,
    description: 'Wildcard',
    statuteName: 'N.D. Cent. Code § 28-22-03.1 (1)',
    limitAggregateSingle: 10000,
    limitAggregateJoint: 20000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    }
  }];
}